// Deployment Version: 1.0.4
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { LanguageProvider } from './context/LanguageContext';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || process.env.GOOGLE_CLIENT_ID || '481763409695-2vabpr44nj4bhua80kgmqu9vjb90vcon.apps.googleusercontent.com';

if (!googleClientId) {
  console.error("Google Client ID is missing! Please set REACT_APP_GOOGLE_CLIENT_ID in your .env file.");
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LanguageProvider>
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    </LanguageProvider>
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
    }
  }).catch(err => {
    console.log('Service Worker unregistration failed: ', err);
  });
}
